"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeSafeCompare = exports.getHmac = void 0;
const crypto_1 = require("crypto");
const getHmacSecret_1 = require("./getHmacSecret");
const HMAC_ALGORITHM = "sha256";
const HMAC_ENCODING = "base64url";
const getHmac = async (data) => {
    const HMAC_SECRET = await (0, getHmacSecret_1.getHmacSecret)();
    const hmac = (0, crypto_1.createHmac)(HMAC_ALGORITHM, HMAC_SECRET);
    hmac.update(data);
    return hmac.digest(HMAC_ENCODING);
};
exports.getHmac = getHmac;
const timeSafeCompare = (input, expectedInput) => {
    const expectedBuffer = Buffer.from(expectedInput);
    const inputBuffer = Buffer.from(input);
    return expectedBuffer.length === inputBuffer.length && (0, crypto_1.timingSafeEqual)(inputBuffer, expectedBuffer);
};
exports.timeSafeCompare = timeSafeCompare;
//# sourceMappingURL=hmac.js.map